import React, { useState, useEffect, useContext } from 'react'
import SiteContext from '@/context/SiteContext'
import Alternativa from './Alternativa'
import HeroPregunta from '@/components/Trivia/Pregunta/HeroPregunta'
import { StaticImage } from 'gatsby-plugin-image'

const Pregunta = ({ data }) => {
  const [selected, setSelected] = useState(false)
  const [isCorrect, setIsCorrect] = useState(false)
  const [correctAnswer, setCorrectAnswer] = useState('')
  const { pregunta, alternativas, respuestaCorrecta } = data

  const { updateActiveQuestion, addAnswer } = useContext(SiteContext)

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [window, selected])

  const handleContinue = () => {
    setSelected(false)
    updateActiveQuestion()
  }

  const handleSelect = payload => {
    addAnswer({
      answer: payload.alternativa,
      pregunta: pregunta,
      respuestaCorrecta: payload.respuestaCorrecta,
      isCorrecta:
        payload.respuestaCorrecta === respuestaCorrecta.respuestaCorrecta,
    })
    setSelected(payload.alternativa)
    setCorrectAnswer(respuestaCorrecta.respuestaCorrecta)
    setIsCorrect(
      payload.respuestaCorrecta === respuestaCorrecta.respuestaCorrecta,
    )
  }

  return (
    <div style={{ maxWidth: '100vw', overflow: 'hidden' }}>
      <div className="sm:mt-10 relative">
        <StaticImage
          className="hidden sm:block"
          layout="fullWidth"
          src="../../../images/bg2.jpg"
          alt=""
          quality={`80`}
          transformOptions={{ fit: 'cover' }}
        />
        <StaticImage
          className="block sm:hidden"
          layout="fullWidth"
          src="../../../images/bgmob.jpg"
          alt=""
          quality={`80`}
          transformOptions={{ fit: 'cover' }}
        />
        <div className="absolute bottom-0 sm:right-10 right-4 sm:w-44 w-16">
          <StaticImage
            layout="fullWidth"
            src="../../../images/logo-ipl.png"
            alt=""
            quality={`80`}
            transformOptions={{ fit: 'cover' }}
          />
        </div>
      </div>
      <div className="enunciado">
        <h2 className="text-2xl font-bold text-center sm:text-3xl landscape:text-xl pt-8 pb-4">
          {pregunta}
        </h2>
      </div>
      <div className={`px-4 alternativas ${selected ? 'shrink' : ''}`}>
        {alternativas.map(alternativa => {
          return (
            <Alternativa
              key={alternativa.alternativa}
              data={alternativa}
              onSelect={payload => handleSelect(payload)}
              pregunta={pregunta}
            />
          )
        })}
      </div>
      <HeroPregunta
        title={pregunta}
        selected={selected}
        correctAnswer={correctAnswer}
        isCorrect={isCorrect}
        onSelect={() => handleContinue()}></HeroPregunta>
    </div>
  )
}

export default Pregunta
